import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              观众热评
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              来自真实用户的观影体验分享
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {comments.slice(0, 3).map((comment) => (
              <div
                key={comment.id}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${i < comment.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4 line-clamp-4">
                  "{comment.content}"
                </p>
                <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.author}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-800">{comment.author}</div>
                    <div className="text-xs text-foreground-500">{comment.date}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
            {comments.slice(3).map((comment) => (
              <div
                key={comment.id}
                className="bg-background-100 rounded-xl p-6 border border-background-200/70"
              >
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-sm ${i < comment.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  "{comment.content}"
                </p>
                <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                  <div className="w-9 h-9 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.author}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-800">{comment.author}</div>
                    <div className="text-xs text-foreground-500">{comment.date}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}